/* tslint:disable */
/* eslint-disable */
/**
 * Careplatform Customer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: jonas.malik@magello.se
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CustomerResponse,
    CustomerResponseFromJSON,
    CustomerResponseFromJSONTyped,
    CustomerResponseToJSON,
    Pagination,
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
} from './';

/**
 * 
 * @export
 * @interface PaginatedCustomerList
 */
export interface PaginatedCustomerList {
    /**
     * 
     * @type {Pagination}
     * @memberof PaginatedCustomerList
     */
    pagination: Pagination;
    /**
     * 
     * @type {Array<CustomerResponse>}
     * @memberof PaginatedCustomerList
     */
    data?: Array<CustomerResponse>;
}

export function PaginatedCustomerListFromJSON(json: any): PaginatedCustomerList {
    return PaginatedCustomerListFromJSONTyped(json, false);
}

export function PaginatedCustomerListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedCustomerList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pagination': PaginationFromJSON(json['pagination']),
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(CustomerResponseFromJSON)),
    };
}

export function PaginatedCustomerListToJSON(value?: PaginatedCustomerList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pagination': PaginationToJSON(value.pagination),
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(CustomerResponseToJSON)),
    };
}


